import { createSlice } from '@reduxjs/toolkit';
import { getApplication } from '../../../shared/redux/applicationSlice';
import { clearForm } from './formSlice';

const initialState = {
  firstName: undefined,
  middleName: undefined,
  lastName: undefined,
  emailAddress: undefined,
  phoneNumber: undefined,
  jobTitle: undefined,
};

const applicantDetailsSlice = createSlice({
  name: 'applicantDetails',
  initialState,
  reducers: {
    storeApplicantDetails(state, action) {
      const applicantDetails = action.payload;
      return { ...applicantDetails };
    },
    storeApplicantNames(state, action) {
      state.firstName = action.payload.firstName;
      state.middleName = action.payload.middleName;
      state.lastName = action.payload.lastName;
    },
    storeJobTitle(state, action) {
      state.jobTitle = action.payload.jobTitle;
    },
    storeApplicantEmail(state, action) {
      state.emailAddress = action.payload.emailAddress;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(clearForm, () => {
        return initialState;
      })
      .addCase(getApplication.fulfilled, (state, action) => {
        return { ...action.payload.applicationData.applicantDetails };
      });
  },
});

export const { storeApplicantDetails, storeApplicantNames, storeJobTitle, storeApplicantEmail } =
  applicantDetailsSlice.actions;
export const applicantDetailsReducer = applicantDetailsSlice.reducer;
